import { GET_BOOKING_FAILED, GET_BOOKING_REQUESTED, GET_BOOKING_SUCCESS} from "resources/actionTypes";

const intialState = {
  userBooking: [],
  loading: false,
  error: null,
};


export function userBooking(state = intialState, action) {
  switch (action.type) {
    case GET_BOOKING_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        userBooking: action.userBooking,
      }
    case GET_BOOKING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}